/* eslint-disable */

import { InjectableClass } from '@fino/lib-injection';

const NotificationType = {
  success: 'success',
  error: 'error',
  warning: 'warning',
};

export class NotificationService extends InjectableClass {
  constructor(
    toastr,
    $filter,
    $stateParams,
    toastrConfig,
    clipboard,
    userService,
    envService,
    $sanitize,
  ) {
    'ngInject';

    angular.extend(toastrConfig, {
      onTap: (t) => {
        const errorMessage = t.el[0].innerText.replace(
          this.translate('app.error-toastr.button.title'),
          '',
        );
        clipboard.copyText(errorMessage);
      },
      autoDismiss: false,
      timeOut: 10000,
      extendedTimeOut: 2000,
      closeButton: true,
    });

    super({
      toastr,
      $filter,
      $stateParams,
      userService,
      envService,
      $sanitize,
    });
  }

  translate(str, params = null) {
    return this.$filter('translate')(str, params);
  }

  success(message, params, title) {
    this.sendNotification(NotificationType.success, message, params, title);
  }

  error(message, params = {}, title = 'app.notify.error') {
    // Translate message and title
    message = this.translate(params.errorKey || message, params);
    title = this.translate(title, params);

    const timestamp = new Date();
    const user = this.userService.get();
    const ticketId = this.$stateParams.ticketId;

    const ticketIdMessage = ticketId
      ? `${this.translate(
          'app.error-toastr.ticketId.title',
        )} <b>${ticketId}</b> <br/>`
      : '';
    const requestIdMessage =
      params && params.requestId
        ? `${this.translate(
            'app.error-toastr.requestId.title',
          )} <b>${this.$sanitize(params.requestId)}</b> <br/> `
        : '';
    const userName = user
      ? `${this.translate(
          'app.error-toastr.userName.title',
        )} <b>${this.$sanitize(user.displayName)}</b><br/>`
      : '';
    const userRole = user
      ? `${this.translate(
          'app.error-toastr.userRole.title',
        )} <b>${this.translate(
          'app.user.role.' + this.$sanitize(user.role),
        )}</b><br/>`
      : '';
    const tenant = `${this.translate(
      'app.error-toastr.tenant.title',
    )} <b>${this.$sanitize(this.envService.getTenant())}</b><br/>`;

    this.toastr.error(
      `${message}\<br/> <br/> 
      <small>${this.translate(
        'app.error-toastr.date.title',
      )} ${timestamp.toLocaleString('de-DE')} <br/></small>
      <small>${ticketIdMessage}</small>
      <small>${requestIdMessage}</small>
      <small>${userName}</small>
      <small>${userRole}</small>
      <small>${tenant}</small>
      <button>${this.translate('app.error-toastr.button.title')}</button>`,
      title,
      {
        allowHtml: true,
      },
    );
  }

  warning(message, params, title) {
    this.sendNotification(NotificationType.warning, message, params, title);
  }

  sendNotification(type, message, params, title) {
    if (!angular.isFunction(this.toastr[type])) {
      throw new Error('Unknown notification type, given: ' + type);
    }
    // Fallback to default type-specific title if missing
    if (!title) {
      title = `app.notify.${type}`;
    }

    // Translate message and title
    message = this.translate(message, params);
    title = this.translate(title, params);

    this.toastr[type](message, title);
  }
}
